function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTileWxOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.23 128.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.14,94.21,90.32,11.38a22.75,22.75,0,0,0-39.41,0L3.08,94.21a22.76,22.76,0,0,0,19.71,34.13h95.65a22.76,22.76,0,0,0,19.7-34.13Z",
    style: {
      fill: "#003173"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.61,91.56a4.67,4.67,0,0,0,4.67-4.66L81,33a10.4,10.4,0,0,0-10.4-10.4h0A10.4,10.4,0,0,0,60.22,33L66,86.9A4.66,4.66,0,0,0,70.61,91.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.61,99a6.52,6.52,0,1,0,6.53,6.52A6.52,6.52,0,0,0,70.61,99Z",
    style: {
      fill: "#fff"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileWxOther);
export default __webpack_public_path__ + "static/media/tile_WXOther.4c90b9b2024dbb1c80289336f0432e10.svg";
export { ForwardRef as ReactComponent };